var responsive = {
  lastScreen : {
    0 : {
      'value' : {
        'height' : null,
        'width' : null
      },
      'name' : {
        'height' : null,
        'width' : null
      }
    }
  },
  screens : {
    'xl'  : {
      'name'      : 'superLgDesktop',
      'maxWidth'  : null,
      'minWidth'  : 1200 + 1
    },
    'lg'  : {
      'name'      : 'lgDesktop',
      'maxWidth'  : 1200,
      'minWidth'  : 992 + 1
    },
    'md'  : {
      'name'      : 'desktop',
      'maxWidth'  : 992,
      'minWidth'  : 768 + 1
    },
    'sm'  : {
      'name'      : 'tablet',
      'maxWidth'  : 768,
      'minWidth'  : 576 + 1
    },
    'xs' : {
      'name'      : 'phone',
      'maxWidth'  : 576,
      'minWidth'  : 0
    },
  },
  getCurrentScreen : {
    value : {
      height : function() {
        return $(window).outerHeight();
      },
      width : function() {
        return $(window).outerWidth();
      }
    },
  },
};

export default responsive;
